import FormHandler from '../../forms/FormHandler';

window.tnew.page.initialize = () => {
  const $form = document.querySelector('#tn-account-create-brief-form') as HTMLFormElement;

  new FormHandler($form);
};
